// types
import { ReportColumnDto } from 'src/api';
// columns
import { AttendanceColumn } from './attendance';
import { AttendedColumn } from './attended';
import { CheckInAtColumn } from './check-in-at';
import { ChurnColumn } from './churn';
import { ClassAttendancePercentageColumn } from './class-attendance-percentage';
import { ClassBeginsColumn } from './class-begins';
import { ClassEndsColumn } from './class-ends';
import { ClassNameColumn } from './class-name';
import { ConvertedColumn } from './converted';
import { CostPriceColumn } from './cost-price';
import { ConvertedToMembershipTypeNameColumn } from './converted-to-membership-type-name';
import { DiscountAmountColumn } from './discount-amount';
import { DiscountChangeColumn } from './discount-change';
import { EndMembershipStatusColumn } from './end-membership-status';
import { FinesColumn } from './fines';
import { FrequencyColumn } from './frequency';
import { IdColumn } from './id';
import { InvoiceNumberColumn } from './invoice-number';
import { IsFeeColumn } from './is-fee';
import { MarginColumn } from './margin';
import { MaximumNumberOfParticipantsColumn } from './maximum-number-of-participants';
import { OwnerNameColumn } from './owner-name';
import { MembershipCategoryNameColumn } from './membership-category-name';
import { MembershipLengthColumn } from './membership-length';
import { MembershipStatusColumn } from './membership-status';
import { MembershipTypeNameColumn } from './membership-type-name';
import { NewMembershipColumn } from './new-membership';
import { OnHoldBeginsColumn } from './on-hold-begins';
import { OnHoldLengthColumn } from './on-hold-length';
import { OnHoldUntilColumn } from './on-hold-until';
import { OrderDateColumn } from './order-date';
import { OrderStatusColumn } from './order-status';
import { OwnerIdColumn } from './owner-id';
import { ParticipationStatusColumn } from './participation-status';
import { PeriodEndColumn } from './period-end';
import { PeriodStartColumn } from './period-start';
import { PriceAmountColumn } from './price-amount';
import { PriceChangeColumn } from './price-change';
import { PriceCurrencyColumn } from './price-currency';
import { ProductNameColumn } from './product-name';
import { ProfitColumn } from './profit';
import { QuantityColumn } from './quantity';
import { RefundsColumn } from './refunds';
import { RenewalDateColumn } from './renewal-date';
import { RevenueColumn } from './revenue';
import { SignedUpAtColumn } from './signed-up-at';
import { SkuColumn } from './sku';
import { StartMembershipStatusColumn } from './start-membership-status';
import { TaxRateColumn } from './tax-rate';
import { TaxRateInclusiveColumn } from './tax-rate-inclusive';
import { TrainerNameColumn } from './trainer-name';
import { ValidFromColumn } from './valid-from';
import { ValidToColumn } from './valid-to';
import { WeekDayColumn } from './week-day';

export function ColumnTemplates() {
  const columns = [
    (index: number) => IdColumn(index),
    (index: number) => OwnerNameColumn(index),
    (index: number) => MembershipLengthColumn(index),
    (index: number) => TrainerNameColumn(index),
    (index: number) => MembershipTypeNameColumn(index),
    (index: number) => ProductNameColumn(index),
    (index: number) => SkuColumn(index),
    (index: number) => MembershipCategoryNameColumn(index),
    (index: number) => StartMembershipStatusColumn(index),
    (index: number) => EndMembershipStatusColumn(index),
    (index: number) => MembershipStatusColumn(index),
    (index: number) => OrderStatusColumn(index),
    (index: number) => FrequencyColumn(index),
    (index: number) => PeriodStartColumn(index),
    (index: number) => PeriodEndColumn(index),
    (index: number) => OrderDateColumn(index),
    (index: number) => ValidFromColumn(index),
    (index: number) => ValidToColumn(index),
    (index: number) => RenewalDateColumn(index),
    (index: number) => OnHoldBeginsColumn(index),
    (index: number) => OnHoldUntilColumn(index),
    (index: number) => QuantityColumn(index),
    (index: number) => PriceAmountColumn(index),
    (index: number) => DiscountAmountColumn(index),
    (index: number) => PriceCurrencyColumn(index),
    (index: number) => CostPriceColumn(index),
    (index: number) => RefundsColumn(index),
    (index: number) => FinesColumn(index),
    (index: number) => TaxRateColumn(index),
    (index: number) => TaxRateInclusiveColumn(index),
    (index: number) => ChurnColumn(index),
    (index: number) => NewMembershipColumn(index),
    (index: number) => RevenueColumn(index),
    (index: number) => ProfitColumn(index),
    (index: number) => MarginColumn(index),
    (index: number) => InvoiceNumberColumn(index),
    (index: number) => ClassAttendancePercentageColumn(index),
    (index: number) => AttendedColumn(index),
    (index: number) => ParticipationStatusColumn(index),
    (index: number) => CheckInAtColumn(index),
    (index: number) => SignedUpAtColumn(index),
    (index: number) => ClassNameColumn(index),
    (index: number) => ClassBeginsColumn(index),
    (index: number) => ClassEndsColumn(index),
    (index: number) => AttendanceColumn(index),
    (index: number) => WeekDayColumn(index),
    (index: number) => ConvertedColumn(index),
    (index: number) => IsFeeColumn(index),
    (index: number) => MaximumNumberOfParticipantsColumn(index),
    (index: number) => ConvertedToMembershipTypeNameColumn(index),
    (index: number) => PriceChangeColumn(index),
    (index: number) => DiscountChangeColumn(index),
    (index: number) => OnHoldLengthColumn(index),
    (index: number) => OwnerIdColumn(index),
  ] as ((index: number) => ReportColumnDto<any, any, any>)[];

  return columns.map((x, i) => x(i));
}
